import React from "react";

import Hidden from "@material-ui/core/Hidden";
import IconButton from "@material-ui/core/IconButton";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Typography from "@material-ui/core/Typography";
import DeleteIcon from "@material-ui/icons/Delete";
import PropTypes from "prop-types";
import { useRouteMatch, useHistory } from "react-router-dom";

import RbScrollView from "components/RbScrollView";
import RbTable from "components/RbTable";
import useAlert from "hooks/useAlert";
import useSnackbar from "hooks/useSnackbar";

function BaseList(props) {
  const { rows, deletePromise, columns, title } = props;

  const history = useHistory();
  const { path } = useRouteMatch();
  const { openSnackbar } = useSnackbar();
  const { openAlert, closeAlert } = useAlert();
  const match = useRouteMatch(`${path}/:idParam`);
  const idParam = match?.params?.idParam;

  const handleDelete = (event, id) => {
    event.stopPropagation();
    openAlert({
      title: "Do you really want delete?",
      message: "This action can't be undone.",
      buttons: [
        {
          text: "Cancel",
        },
        {
          text: "Delete",
          color: "secondary",
          onClick: () => {
            deletePromise({
              variables: { input: { id } },
            }).then(() => {
              closeAlert();
              if (id === idParam) {
                history.push(path);
              }
              openSnackbar({ message: "Deleted successfully." });
            });
          },
        },
      ],
    });
  };

  const handleClickRow = (id) => {
    history.push(`${path}/${id}`);
  };

  return (
    <RbScrollView p={{ xs: 2, md: 8 }}>
      <Hidden smDown>
        <Typography variant="h6" component="h2" paragraph>
          {title}
        </Typography>
      </Hidden>
      <RbTable aria-label="simple table" variant="striped">
        <TableHead>
          <TableRow>
            {columns.map((column) => (
              <TableCell key={column.header}>{column.header}</TableCell>
            ))}
            <TableCell />
          </TableRow>
        </TableHead>
        <TableBody>
          {rows?.map((row) => (
            <TableRow
              key={row.id}
              hover
              onClick={() => handleClickRow(row.id)}
              selected={idParam === row.id}
            >
              {columns.map((column) => (
                <TableCell key={column.header}>{column.body(row)}</TableCell>
              ))}
              <TableCell align="right">
                <IconButton
                  size="small"
                  onClick={(event) => handleDelete(event, row.id)}
                >
                  <DeleteIcon />
                </IconButton>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </RbTable>
    </RbScrollView>
  );
}

BaseList.propTypes = {
  columns: PropTypes.array.isRequired,
  deletePromise: PropTypes.func.isRequired,
  rows: PropTypes.array.isRequired,
  title: PropTypes.string.isRequired,
};

export default React.memo(BaseList);
